<div class="page-title-area">
    <div class="container-fluid">
        <div class="page-title-content">
            <h2 data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">Email</h2>
            <ul data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>Email</li>
            </ul>
        </div>
    </div>

</div>

<section class="team-area ">
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">

                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/mobile-chatbot.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-sm-2 ">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                             Effortless Sending
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Send bulk emails efficiently with a user-friendly API that integrates seamlessly with your website.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Targeted Campaigns
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Segment your audience based on various criteria and personalize emails for improved engagement. (e.g., demographics, purchase history, website behavior).
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Targeted-Campaigns.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Template-Library.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Template Library
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Create and save reusable email templates for consistent branding and faster campaign creation.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Rich Content Support
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Include images, videos, and calls to action (CTAs) within emails for a visually appealing and interactive experience.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Rich-Content-Support.png" alt="image" style="max-width: 90%;" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Scheduled-Delivery.png" alt="image"  style="max-width: 70% !important; "/>
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                           Scheduled Delivery
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Schedule emails to be sent at optimal times for maximum impact, like welcome messages after signup.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Real-time Analytics
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Track key metrics like open rates, click-through rates, and unsubscribes to measure campaign effectiveness.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Real-Time.png" alt="image"  />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/spam-handling.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                             Bounce & Spam Handling
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Identify and manage bounced emails and improve sender reputation to avoid spam filters.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Event Triggers
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Automate email sending based on user actions (e.g., abandoned cart reminder, birthday offer).
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Event-Triggers.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">

                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Increased-Efficiency.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-sm-2 ">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                               Increased Efficiency
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Automate email sending and save time on repetitive tasks.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                        Improved Targeting
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Reach the right audience with relevant messages for better engagement.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Improved-Targeting.png" alt="image" style="max-width: 80%;"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Enhanced-Personalization.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Enhanced Personalization
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Build stronger relationships with customers through personalized communication.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Data-Driven Optimization
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Track results and optimize campaigns for continuous improvement.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Data-Driven.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Cost-Effectiveness.png" alt="image"  style="max-width: 70% !important; "/>
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                         Cost-Effectiveness
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Reach a large audience at a lower cost compared to traditional marketing channels.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                         Reporting & Exports
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Generate detailed reports and export data for further analysis in external tools.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Exports.png" alt="image" style="max-width: 55%;" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Scalability-2.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                             Scalability
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           The API should handle large email volumes without compromising performance
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                          Security
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                            Ensure secure data storage and transmission with encryption and access controls.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Security-2.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>

 


    <div class="container-fluid" style="padding-top: 80px; padding-bottom: 80px;">
      

        <div class="pricing">
            <h3 style="text-align: center; font-size: 24px; ">Pricing</h3>
            <div class="container">
            <table>
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Product Name</th>
                        <th>Quantity Slab</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>E-mail</td>
                        <td>1 Lakh@8 Paise</td>
                        <td>Rs. 8,000/-</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>E-mail</td>
                        <td>5 Lakh@7 Paise</td>
                        <td>Rs. 35,000/-</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>E-mail</td>
                        <td>10 Lakh@6 Paise</td>
                        <td>Rs. 60,000/-</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>E-mail</td>
                        <td>1 Crore@5 Paise</td>
                        <td>Rs. 5,00,000/-</td>
                    </tr>
                    
                </tbody>
            </table>
        </div>
            <h3>Pricing: (GST Exclusive, as applicable)</h3>
        </div>
        
    </div>


</section>
<div class="full-row" #seprator id="seprator">
    <div class="container-fluid">
        <h6>
            Want to Improve the Experience of Your Customers? Our Dedicated Team Is Here to Help You Out!


        </h6>
        <a class="btns btn-primarys" routerLink="/contact">
            CONTACT US
        </a>
    </div>
</div>
